import Vue from 'vue';
import VueTheMask from 'vue-the-mask';
import Toasted from 'vue-toasted';
import Vuelidate from 'vuelidate';
import { VueReCaptcha } from 'vue-recaptcha-v3';

//use
Vue.use(Toasted, {
  duration: 3000,
  position: 'top-right'
});
// Vue.use(VueAnimate);
Vue.use(VueTheMask);
Vue.use(Vuelidate);
Vue.use(VueReCaptcha, { siteKey: `${process.env.VUE_APP_RECAPTCHA_KEY}` });
